import {
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import TambahSilabusCourseModal from "./TambahSilabusCourseModal";
import { MagnifyingGlass } from "@phosphor-icons/react";
import SilabusTable from "./SilabusTable";

export default function CourseSilabusEdit() {
  const [search, setSearch] = useState<string>("");
  const [orderLoading, setOrderLoading] = useState<boolean>(false);

  return (
    <VStack align={"stretch"} gap={0} flex={1}>
      <HStack justify={"space-between"} p={5}>
        <InputGroup>
          <InputLeftElement>
            <Icon as={MagnifyingGlass} />
          </InputLeftElement>
          <Input
            maxW={"400px"}
            placeholder="Pencarian"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </InputGroup>

        <TambahSilabusCourseModal />
      </HStack>

      <SilabusTable
        search={search}
        orderLoading={orderLoading}
        setOrderLoading={setOrderLoading}
      />
    </VStack>
  );
}
